import http from "../http/http-config";
import { CityByPostalResponse } from "../models/CityByPostal";

export default new class CityByPostalAndLocalService {
    GetCityByPostalAndLocal(cityCode: number, zipCode: number, country: number): Promise<CityByPostalResponse> {
        return http.get<CityByPostalResponse>("CityByPostalAndLocal", {
            params: {
                cityCode, zipCode, country
            }
        }).then(response => response.data)
    }
}
